import React from 'react';
import '../css/todoitem.css'

const ToDoItem = ({text, checked, id, onToggle, onRemove}) => {
    return (
        <div className='todo-item' onClick={()=>onToggle(id)}>
            <div className='remove' onClick={(e)=>{e.stopPropagation(); onRemove(id)}}>
                &times;      
            </div>
            <div className={`todo-text ${checked&&'checked'}`}>
                <div>{text}</div>
            </div>
            {
                checked&& (<div className='check-mark'>✔</div>)
            }
            <div className=''>
                
            </div>
        </div>
    );
}

export default ToDoItem;